import React from "react";

import { Typography } from "clearsense-ui/components";
import { snakeCaseToTitleCase } from "components/DataIngestion/SourceDatabases/utils";

const StatItem = ({ name, value, isPercent }) => {
  const getColor = percent => {
    if (percent > 66.66) {
      return "#62BD69";
    } else if (percent > 33.33) {
      return "#FF9D5C";
    }

    return "#F94449";
  };

  return (
    <div className="flex flex-col bg-gray-100">
      <div className="flex justify-between p-3 w-100">
        <Typography type="semibold">{snakeCaseToTitleCase(name)}</Typography>
        <Typography type="semibold">{`${value}${
          isPercent ? "%" : "x"
        }`}</Typography>
      </div>

      {isPercent && (
        <div className="w-full bg-gray-200">
          <div
            style={{
              height: "10px",
              width: `${value}%`,
              background: getColor(value),
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default StatItem;
